module.exports = __webpack_public_path__ + "static/media/fg_my.d2d11eed.png";